<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Multiple Range Slider
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<ng-container *ngIf="isBrowser;else noJsContent">
  <div class="content content--modifier-height">
    <h2>Customized useCase options for Multi-range-slider</h2>
    <div class="content__tools-wrap">
      <div class="content__row">
        <label for="useCase" class="content__row-label">Use Cases</label>
        <select [(ngModel)]="selectedUseCase" class="c-input-group__control" id="useCase">
          <ng-container *ngFor="let useCase of useCases">
            <option [value]="useCase">{{ useCase }}</option>
          </ng-container>
        </select>
        <div class="content__row-check-col">
          <input id="showSliderIntervals" class="c-input-check-inline__input" type="checkbox" name="showSliderIntervals"
            [(ngModel)]="showSliderIntervals">
          <label for="showSliderIntervals" class="c-input-check-inline__label">Show Slide Intervals</label>
        </div>
      </div>
    </div>
    <div *ngIf="selectedUseCase === 'Horizontal Slider'">
      <maced-multi-range-slider [minValue]="mininput" [maxValue]="maxinput" [minLimit]="minlimit" [maxLimit]="maxlimit"
        [midValue]='midValue' (sliderValueChanged)="updateValues($event, 'horizontal')"
        [showSliderIntervals]="showSliderIntervals">
      </maced-multi-range-slider>
    </div>
    <div *ngIf="selectedUseCase === 'Vertical Slider'">
      <maced-multi-range-slider [showVerticalSlider]="true" [minValue]="verticalMininput" [maxValue]="verticalMaxinput"
        [minLimit]="verticalMinlimit" [maxLimit]="verticalMaxlimit" [midValue]='verticalMidValue'
        (sliderValueChanged)="updateValues($event, 'vertical')" [showSliderIntervals]="showSliderIntervals">
      </maced-multi-range-slider>
    </div>
  </div>
</ng-container>
<ng-template #noJsContent>
  <div class="content">
    <form action="/multi-range-slider">
      <div class="c-range-nojs">
        <div class="c-range-nojs__span">
          <label for="min"></label>
          <p class="c-range-nojs__span-info">{{ mininput }} min - {{ maxinput }} max</p>
        </div>
        <div class="c-range-nojs__slider">
          <input type="range" id="min" name="min" min="{{minlimit}}" max="{{maxlimit}}" [value]="mininput">
          <input type="range" id="max" name="max" min="{{minlimit}}" max="{{maxlimit}}" [value]="maxinput"> 
        </div>
        <button type="submit">Submit</button>   
      </div>    
    </form>
  </div>
</ng-template>